import Vue from 'vue'
import router from './router'
import App from './App.vue'
import filter from './filter'
import api from './constant/api'
import NutUI from '@nutui/nutui';

NutUI.install(Vue);

Array.prototype.getIds = function (){//获取id数组
    let res = [];
    for (let i = 0; i < this.length; i++) {
        let obj = this[i];
        res.push(obj.id);
    }
    return res;
}

Array.prototype.getNum = function (){//获取Num数组
    let res = [];
    for (let i = 0; i < this.length; i++) {
        let obj = this[i];
        res.push(obj.num);
    }
    return res;
}

Vue.prototype.api = api;

Vue.prototype.baseUrl = window.config.getUploadFileUrl;

Vue.prototype.bMapToQQMap = (lng, lat) => { //百度地图转腾讯地图
    let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
    let x = lng - 0.0065;
    let y = lat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    lng = z * Math.cos(theta);
    lat = z * Math.sin(theta);
    return [parseFloat(lng), parseFloat(lat)];
}

Vue.prototype.jssdkConfig = async (jsApiList) =>{	//获取jssdk
    console.log('configurating Jssdk 。。。。。。。。。。')
    // console.log('444')
    let url = window.config.wxUrl + '/#' + window.entryUrl;
    // alert(url)
    let res = await api.post('getJssdk',{url,jsApiList,debug:false});
    let obj = res.data.data;
    wx.config({
        debug: false,
        appId: obj.appId, // 必填，公众号的唯一标识
        timestamp: obj.timestamp, // 必填，生成签名的时间戳，精确到秒
        nonceStr: obj.nonceStr, // 必填，生成签名的随机串
        signature: obj.signature, // 必填，签名
        jsApiList: obj.jsApiList
    })
}

Vue.prototype.pay = obj => {//jsapi支付
    // let {appId,timeStamp,nonceStr,package,signType,paySign} = obj;
    // alert(JSON.stringify(obj));
    return new Promise((resolve, reject) => {
        WeixinJSBridge.invoke('getBrandWCPayRequest', obj,function (res) {
                //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                console.log(res);
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    resolve(res);
                } else {
                    console.log('调用支付失败')
                    reject(res);
                }
            }
        )
    })
}

for(let p in filter){//遍历对象属性，加载所有方法到filter
    Vue.filter( p ,filter[p]);
}

let vm = new Vue({
    el: '#app',
    router,
    render: h => h(App)
}).$mount('#app');
export default vm//导出这个实
